import axios from 'axios'
import '../Config'

const jwtToken = localStorage.getItem("authorization");

const INSTRUCTOR = 'v1'
const COURSE_API_URL = global.config.backend
const INSTRUCTOR_API_URL = `${COURSE_API_URL}/${INSTRUCTOR}`

class ProdutoService {

    /*getAll() {
        return axios.get(`${INSTRUCTOR_API_URL}/produto/getall`,
                        {headers: {
                            Authorization: "Bearer " + jwtToken
                        }});
    }*/

    getAll() {
        return axios.get(`${INSTRUCTOR_API_URL}/produto/getall`);
    }

}

export default new ProdutoService()